// extracted by mini-css-extract-plugin
module.exports = {"slide":"st_slide__6UwP4","columnLabel":"st_columnLabel__QVYof"};